module.exports = __webpack_public_path__ + "img/replay-video.cc56b46c.svg";